import service from "../libs/request.js";

// 获取乘车路线列表
var getBusList = function(postdata, callback) {
  service.get({
    url: "/wzHosOverview/getBusList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取门诊就诊流程图
var getFlowInfo = function(postdata, callback) {
  service.get({
    url: "/wzHosOverview/getFlowInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取楼层分布列表
var getFloorList = function(postdata, callback) {
  service.get({
    url: "/wzHosOverview/getFloorList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取楼层分布
var getFloorInfo = function(postdata, callback) {
  service.get({
    url: "/wzHosOverview/getFloorInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取就诊须知
var getNoticeInfo = function(postdata, callback) {
  service.get({
    url: "/wzHosOverview/getNoticeInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取联系我们列表
var getContactusList = function(postdata, callback) {
  service.get({
    url: "/wzHosOverview/getContactusList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

export default {
  getBusList,
  getFlowInfo,
  getFloorList,
  getFloorInfo,
  getNoticeInfo,
  getContactusList,
};
